export const QUERY_KEYS = {
  VERIFY_FORM_LINK: 'verifyFormLink',
  FETCH_FORM_DATA_BY_ID: 'fetchFormDataById',
};

export const MUTATION_KEYS = {
  SEND_GUEST_OTP: 'sendGuestOTP',
  VERIFY_GUEST_OTP: 'verifyGuestOTP',
  SAVE_INFO: 'saveInfo',
  SAVE_RESPONSE: 'saveResponse',
};

const BASE_USER_URL = '/v1.1/user/';
const BASE_FORM_LINK_URL = '/v1.1/form-link/';
const BASE_FORM_URL = '/v1.1/custom-form/';

export const ENDPOINTS = {
  FETCH_FORM_DATA_BY_ID: (id: string) => `${BASE_FORM_URL}${id}`,
  SEND_GUEST_OTP: `${BASE_USER_URL}send_guest_otp/`,
  VERIFY_GUEST_OTP: `${BASE_USER_URL}verify_guest_otp/`,
  SAVE_INFO: `${BASE_USER_URL}complete_guest_onboarding/`,
  VERIFY_FORM_LINK: (id: string) =>
    `${BASE_FORM_LINK_URL}verify-form-link/${id}`,
  SAVE_RESPONSE: 'v1.1/submission/',
};
